/* @flow */

export const API_KEY = 'AIzaSyD-g-8qpvdaYraAF0WtW1CL3n5Jx9PxbXM';
